import { render, staticRenderFns } from "./ReversionGPage.vue?vue&type=template&id=400f0774"
import script from "./ReversionGPage.js?vue&type=script&lang=js&external"
export * from "./ReversionGPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports